import styles from "./toolbox-all-backdrops.module.css";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { useEditorUI } from "PosterEditor/use-editor-ui";
import { DeleteButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { Element } from "PosterEditor/model/poster-types";
import { Reorder, useDragControls } from "framer-motion";
import { Backdrop } from "PosterEditor/model/poster-project";
import { useState } from "react";
import { DragHandle } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";

interface ToolboxAllLabelsProps {}

export const ToolboxAllBackdrops = (props: ToolboxAllLabelsProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Labels</h1>
      </div>
      <div className={styles.content}>
        <BackdropList />
      </div>
    </div>
  );
};

const elementFromBackdrop = (backdrop: Backdrop): Element => {
  return {
    type: "backdrop",
    id: backdrop.id,
    backdrop: backdrop,
  };
};

const BackdropList = () => {
  const { project, removeBackdrop, setBackdrops } = usePosterProject();
  const { setEditingElement } = useEditorUI();

  return (
    <div className={styles.labelList}>
      <span className={styles.title}>Static Labels</span>
      <Reorder.Group
        as="div"
        class={styles.listContent}
        values={project.backdrops.map((b) => b.id)}
        onReorder={(ids) => {
          const reordered = ids.map(
            (id) => project.backdrops.find((b) => b.id === id)!
          );
          setBackdrops(reordered);
        }}
        className={styles.reorderGroup}
      >
        {project.backdrops.map((backdrop, index) => (
          <ListItem
            backdrop={backdrop}
            index={index}
            key={backdrop.id}
            onClick={() => setEditingElement(elementFromBackdrop(backdrop))}
            onDelete={() => {
              removeBackdrop(backdrop);
            }}
          />
        ))}
      </Reorder.Group>
    </div>
  );
};

interface ListItemProps {
  backdrop: Backdrop;
  index: number;
  onClick: () => void;
  onDelete: () => void;
}

const ListItem = (props: ListItemProps) => {
  const { backdrop, index, onClick, onDelete } = props;

  const controls = useDragControls();
  const [isDragging, setIsDragging] = useState(false);

  const titleForBackdrop = (index: number) => {
    return backdrop.name ?? `Backdrop ${index + 1}`;
  };

  return (
    <Reorder.Item
      key={backdrop.id}
      value={backdrop.id}
      custom={backdrop}
      layout
      style={{ listStyleType: "none" }}
      dragListener={false}
      dragControls={controls}
      onDragStart={() => setIsDragging(true)}
      onDragEnd={() => setTimeout(() => setIsDragging(false), 0)}
    >
      <div key={backdrop.id} className={styles.item}>
        <div
          onPointerDown={(e) => {
            e.stopPropagation();
            controls.start(e);
          }}
        >
          <DragHandle />
        </div>
        <button
          className={styles.itemButton}
          onClick={() => {
            if (!isDragging) {
              props.onClick();
            }
          }}
        >
          <div className={styles.itemContentLeading}>
            <h3>{titleForBackdrop(index)}</h3>
            {/* <span className={styles.latLong}>{backdrop.id}</span> */}
          </div>
        </button>

        <DeleteButton
          onClick={() => {
            props.onDelete();
          }}
        />
      </div>
    </Reorder.Item>
  );
};
